<template>
    <base-card>
        <form>
            <div class="mb-4">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="username">
                    Username
                </label>
                <base-input-field :class="{ 'border-red-500': error }" id="username" type="text" placeholder="Username" v-model="username" @input="error = false"></base-input-field>
            </div>
            <div class="mb-6">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="password">
                    Password
                </label>
                <base-input-field :class="{ 'border-red-500': error }" id="password" type="password" placeholder="******************" v-model="password" @input="error = false"></base-input-field>
                <p class="text-red-500 text-xs italic mt-2" v-if="error">Incorrect login details.</p>
            </div>
            <div class="flex items-center justify-between">
                <button class="text-white font-bold py-2 px-4 rounded focus:outline-none" :class="{ 'bg-blue-500 hover:bg-blue-700 cursor-pointer focus:shadow-outline': readyToSubmit, 'bg-gray-400 cursor-not-allowed': ! readyToSubmit }" type="button" :disabled="! readyToSubmit" @click="login">
                    Sign In
                </button>
            </div>
        </form>
    </base-card>
</template>

<script>
    export default {
        data() {
            return {
                username: null,
                password: null,
                error: false,
            }
        },
        methods: {
            login() {
                if (! this.readyToSubmit) {
                    return;
                }

                axios.post(route('authenticate'), {
                    username: this.username,
                    password: this.password,
                }).then(function (response) {
                    if (! response.data.success) {
                        this.error = true;
                        return;
                    }

                    window.location.href = route('administration.dashboard');
                }.bind(this)).catch(function () {
                    this.error = true;
                }.bind(this));
            },
        },
        computed: {
            readyToSubmit() {
                return this.username && this.password;
            },
        },
    }
</script>
